import { ChangeEvent, useCallback, useState } from "react";
import { getItemPopupList } from "src/apis/itemApi";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { ItemDto } from "src/dtos/item/itemDto";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from '../../../../store/useCommonCodeStore';
import { defaultKSK2070_R01Filter, useKSK2070_R01Store } from "./Store_KSK2070_R01";
import { CompanyDto } from "src/dtos/company/companyDto";
import { inputFormHeightOption, searchLabelStyle } from "src/components/common/common";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";


interface Props {
    className?: string;
}

export const SearchSection_KSK2070_R01 = ({ 
}: Props) => {

	const {
		KSK2070_R01Filter, setKSK2070_R01Filter,
		showSubtotals, setShowSubtotals,
		subtotalData,
		dateSubtotalData,
		KSK2070_R01List
	 } = useKSK2070_R01Store();

	 const { 
		brandCdList,
		compCdList,
	} = useCommonCodeStore();

    // 달력 팝업 노출 여부 상태
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
    
    const { setCodeSearchModalProps } = useUiuxStore();

	const itemCdHandleFoucsId = 'itemCd_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'itemCd',
			category: '품목코드',
			focusId: itemCdHandleFoucsId,
			responseMapping: {
				itemCd: 'itemCd',
				itemNm: 'itemNm',
			},
			extraFilter: () => ({
				itemCd: KSK2070_R01Filter.itemCd || '',
				itemNm: KSK2070_R01Filter.itemNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: KSK2070_R01Filter,
		setEditData: setKSK2070_R01Filter,
		defaultData: defaultKSK2070_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'KSK2070_R01_search'
	});

    // 확장 검색 영역 렌더링 (소계 제어만 추가)
    const expandSearch = () => {
        return (
            <div className="flex items-center justify-end h-full gap-[8px] px-[12px] rounded-[6px]  ">
                <button
                    onClick={() => setShowSubtotals(!showSubtotals)}
                    className={`px-4 rounded-md font-medium transition-colors ${inputFormHeightOption} ${
                        showSubtotals 
                            ? 'bg-blue-100 text-black-700 hover:bg-blue-200 border border-black-300' 
                            : 'bg-white text-gray-9 00 hover:bg-gray-200 border border-gray-300'
                    }`}
                    title={showSubtotals ? '소계 숨기기' : '소계 표시하기'}
                >
                    {showSubtotals ? '소계 숨기기' : '소계 표시'}
                </button>
				
                <SearchDropDownForm<SysCodeDto>
                    label="브랜드"
                    value={KSK2070_R01Filter.brandCd}
                    optionList={brandCdList}
                    onChangeValue={v => setKSK2070_R01Filter({ brandCd: v === 'all' ? '' : v })}
					wrapperOption={{
						wrapperStyle: "w-[200px] min-w-[200px]",
						titleStyle: searchLabelStyle,
						selectStyle: 'w-[120px] min-w-[120px]', 
					}}
                />

            </div>
        );
    };

    return (
        <div className="w-full ">
            <SearchSectionForm expandSearch={expandSearch} buttonText="소계검색">
                <SearchDropDownForm<CompanyDto>
                    label="사업장"
                    value={KSK2070_R01Filter.compCd}
                    optionList={compCdList}
                    onChangeValue={v => setKSK2070_R01Filter({ compCd: v === 'all' ? '' : v })}
					wrapperOption={{
						wrapperStyle: "w-[270px] min-w-[270px] mr-[10px]",
						titleStyle: searchLabelStyle,
						selectStyle: "w-[180px] min-w-[180px]",
					}}
                />
                <SearchDateRangeForm
                    label="생산일자"
                    visible={pickerVisible}
                    setVisible={setPickerVisible}
                    dateRange={KSK2070_R01Filter.productDateRange}
                    setDateRange={v => setKSK2070_R01Filter({ productDateRange: v })}
                    pickerPosition={pickerPosition}
                    setPickerPosition={setPickerPosition}
                />
                <SearchCodeModalForm
                    label="품목코드"
                    value={KSK2070_R01Filter.itemCd}
                    valueLabel={KSK2070_R01Filter.itemNm}
					handleFoucsId={itemCdHandleFoucsId}
                    onChange={getFieldHandlers('itemCd').onChange}
                    onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
                    onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
					wrapperOption={{
						wrapperStyle: "w-[500px] min-w-[500px] mr-[10px]",
						titleStyle: "w-[90px] min-w-[90px] text-left",
						codeInputStyle: "w-[190px] min-w-[190px]",
						nameTagStyle: "w-[200px] min-w-[200px] text-left",
					}}
                />
            </SearchSectionForm>
        </div>
    );
};
